function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Dropdown from "../Dropdown/Dropdown";
import DropdownContent from "../Dropdown/DropdownContent";
import DropdownContext from "../Dropdown/DropdownContext";
import DropdownSource from "../Dropdown/DropdownSource";
import DropdownTarget from "../Dropdown/DropdownTarget";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
/**
 * Shows help text on click
 **/

export default class UsageHint extends PureComponent {
  render() {
    const {
      children,
      inline,
      iconName,
      padding,
      width,
      spaceLeft,
      spaceRight,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(Dropdown, _extends({}, rest, {
      showArrow: true
    }), /*#__PURE__*/React.createElement(DropdownTarget, null, /*#__PURE__*/React.createElement(Link, {
      style: "subtle"
    }, /*#__PURE__*/React.createElement(Icon, {
      inline: inline,
      spaceLeft: spaceLeft,
      spaceRight: spaceRight,
      name: iconName,
      size: "1rem"
    }))), /*#__PURE__*/React.createElement(DropdownSource, null, /*#__PURE__*/React.createElement(DropdownContext, {
      width: width
    }, /*#__PURE__*/React.createElement(DropdownContent, {
      padding: padding
    }, children))));
  }

}

_defineProperty(UsageHint, "defaultProps", {
  inline: false,
  iconName: "question-mark-circle",
  padding: "large",
  showArrow: true
});